import { useTranslation } from 'react-i18next';
import { Button, Flex, spaces } from '@electricjs/arc';
import { EventTypeFilter } from '@/components/Assets/AssetEventsHistory/EventTypeFilter';
import { CategoryFilter } from '@/components/Assets/AssetEventsHistory/CategoryFilter';
import { AssetEventCategory, ActionType } from '@electricjs/core_entity-client';
import { useSearchParams } from 'react-router-dom';
import { AssetEventsHistoryQueryParams } from '@/types/queryParamKeys';
import { setQueryParamList } from '@/helpers/setQueryParamList';

const TableFiltersGroup = () => {
  const { t } = useTranslation('assets');
  const [queryParams, setQueryParams] = useSearchParams();

  const eventTypes =
    queryParams.getAll(AssetEventsHistoryQueryParams.EventTypes) ?? [];
  const categories =
    queryParams.getAll(AssetEventsHistoryQueryParams.Categories) ?? [];

  const showClearButton = eventTypes.length > 0 || categories.length > 0;

  const handleClearAllFilters = () => {
    const newQueryParams = new URLSearchParams(queryParams);
    newQueryParams.delete(AssetEventsHistoryQueryParams.EventTypes);
    newQueryParams.delete(AssetEventsHistoryQueryParams.Categories);
    setQueryParams(newQueryParams, { replace: true });
  };

  const handleUpdateEventType = (eventTypes: ActionType[]) => {
    const key = AssetEventsHistoryQueryParams.EventTypes;
    const updated = setQueryParamList(queryParams, key, eventTypes);
    if (updated) setQueryParams(updated, { replace: true });
  };

  const handleUpdateCategory = (newCategories: AssetEventCategory[]) => {
    const key = AssetEventsHistoryQueryParams.Categories;
    const updated = setQueryParamList(queryParams, key, newCategories);
    if (updated) setQueryParams(updated, { replace: true });
  };

  const { space_l, space_m } = spaces;

  return (
    <Flex
      justifyContent="space-between"
      flexGrow="1"
      px={space_l}
      py={space_m}
      gap={space_m}>
      <Flex gap={space_m} alignItems="center" flexWrap="wrap">
        <EventTypeFilter
          eventTypes={eventTypes as ActionType[]}
          handleAddEventType={handleUpdateEventType}
        />
        <CategoryFilter
          categories={categories as AssetEventCategory[]}
          handleAddCategory={handleUpdateCategory}
        />
        {showClearButton && (
          <Button
            id=" clear-all-filters"
            variant="text"
            intent="primary"
            size="small"
            onClick={handleClearAllFilters}>
            {t('eventsHistory.filters.clearAll')}
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default TableFiltersGroup;
